import { addCss } from '@zk/framework-vue';
import { guideRecord } from '@/api/guide';
import store from '@/store';
const SCOPED_NAME = 'app-ui-driver';

const insertCurrentCss = (options) => {
  return addCss(SCOPED_NAME, () => (`
    .${SCOPED_NAME}-dialog.el-message-box {
      box-shadow: 0px 8px 18px 0px rgba(32, 55, 85, 0.16);
      border-radius: 16px;
      padding: 0;
      width: auto;
    }
    .${SCOPED_NAME}-dialog.el-message-box .el-message-box__btns {
      display: none;
    }
  `), options);
};

const showDialog = vue => new Promise((resolve, reject) => {
  const toDoc = () => window.open(vue.$config.getDocUrl('SYSTEM_UI_UPDATE'), '_blank');
  // eslint-disable-next-line no-unused-vars
  const h = vue.$createElement;
  vue.$msgbox({
    title: '全新UI升级',
    customClass: `${SCOPED_NAME}-dialog`,
    showConfirmButton: false,
    showCancelButton: false,
    closeOnClickModal: false,
    closeOnPressEscape: false,
    message: (
      <div>
        <div>
          <el-image src={require('@/assets/ui-guide.gif')} style="width: 460px;height: 320px;" />
        </div>
        <div style="margin-top: 16px;">
          提供更易用、高效和舒适的使用体验
        </div>
        <el-row type="flex" align="middle" justify="end" style="margin-top: 32px;">
          <el-link style="margin-right: 16px;" type="primary" icon="zkicon iconlianjie1" onClick={toDoc}>
            了解更多
          </el-link>
          <el-button type="primary" round onClick={() => {
            vue.$msgbox.close();
            resolve();
          }}>
            开始使用
          </el-button>
        </el-row>
      </div>
    )
  }).catch(reject);
});

const GUIDE_TYPE = 40;
export const showGuideIfNeeded = async vue => {
  if ((vue.$route.query.pid && vue.$route.query.issueid) || vue.$route.meta?.hideAside === true) {
    return;
  }
  // 要等token验证成功后才可以初始化，不然会未登录
  const unwatch = store.watch(state => !!state.user.account?.userId && !!state.user.token, async (isLogin) => {
    if (isLogin) {
      if (!store.getters['user/isAnonymous']) {
        const guideList = store.state.guide.guideInfoList;
        const guide = guideList?.find(g => g.guideType === 19);
        const navGuide = guideList?.find(g => g.guideType === GUIDE_TYPE);

        if (!guide || guide.enabled !== 1) {
          await guideRecord(GUIDE_TYPE);
          store.dispatch('guide/queryGuideInfo', true);
          return;
        }

        if (!navGuide || navGuide.enabled === 1) {
          return;
        }
        await guideRecord(GUIDE_TYPE);
        store.dispatch('guide/queryGuideInfo', true);
        insertCurrentCss({ auto: true });
        showDialog(vue);
      }
      setTimeout(() => unwatch(), 1000);
    }
  }, { immediate: true });
};
